<template>
  <div><el-overlay-loading loading /></div>
</template>

<script>
export default {
  data() {
    return {
      id: null,
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
  },
  created() {
    this.getParams()
  },
  methods: {
    getParams() {
      this.$axios
        .get(`products/${this.getId}`)
        .then((res) => {
          if(res.data.rejected){
            return this.$router.push({
              name: 'savInfoPage',
              params: {
                type: 'rejected',
              },
            })
          }
          if(res.data.unreviewed){
            return this.$router.push({
              name: 'savInfoPage',
              params: {
                type: 'unreviewed',
              },
            })
          }
          const productType = res.data.product_type
          const objectId = res.data.object_id
          switch (productType) {
            case 'in_journal':
              this.$router.push({
                name: 'savDocumentView',
                params: {
                  id: objectId,
                  productLink: 1
                },
              })
              break
            case 'statement_order':
              this.$router.push({
                name: 'savOrderView',
                params: {
                  id: objectId,
                },
              })
              break
            default:
              break
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
  },
}
</script>

<style></style>
